import React from "react";

// Same pill shape as StatusBadge, in the colours the dashboard already gives
// each source: the History panel's warm grey for events, the Independent
// Service panel's cream for logged work.
const BADGE_STYLES = {
    event: "bg-[#e2dcd7] text-[#6e4e37]",
    independent: "bg-[#ffeec6] text-[#8a6a1f]",
};

// Uppercase in the DOM (not CSS) so accessible names and tests see the visible
// label, and so these never collide with the "Event" source filter button.
const BADGE_LABELS = { event: "EVENT", independent: "INDEP" };

export default function SourceBadge({ source }) {
    return (
        <span
            className={`inline-block px-[14px] py-[3px] rounded-full text-[14px] tracking-[0.8px] whitespace-nowrap ${
                BADGE_STYLES[source] || BADGE_STYLES.independent
            }`}
        >
            {BADGE_LABELS[source] || source}
        </span>
    );
}
